import EmbedHtml from '@/components/embeds/EmbedHtml/EmbedHtml'
import styles from './EmbedPodcast.module.scss'
import Icons from './Icons'

export type PodcastUrls = {
  readonly amazon?: string
  readonly apple?: string
  readonly google?: string
  readonly rss?: string
  readonly rtl?: string
  readonly spotify?: string
}

const EmbedPodcast = ({ html, podcastUrls }: { html: string; podcastUrls?: PodcastUrls }) => (
  <div className={styles.wrapper}>
    <EmbedHtml html={html} />
    {podcastUrls && (
      <div className={styles.abo}>
        {podcastUrls.rtl && (
          <a href={podcastUrls.rtl} title="RTL+" target="_blank">
            {Icons['rtlplus']}
          </a>
        )}
        {podcastUrls.apple && (
          <a href={podcastUrls.apple} title="Apple Podcasts" target="_blank">
            {Icons['apple']}
          </a>
        )}
        {podcastUrls.spotify && (
          <a href={podcastUrls.spotify} title="Spotify" target="_blank">
            {Icons['spotify']}
          </a>
        )}
        {podcastUrls.amazon && (
          <a href={podcastUrls.amazon} title="Amazon Music" target="_blank">
            {Icons['amazon']}
          </a>
        )}
        {podcastUrls.google && (
          <a href={podcastUrls.google} title="google" target="_blank">
            {Icons['google']}
          </a>
        )}
        {podcastUrls.rss && (
          <a href={podcastUrls.rss} title="Feed" target="_blank">
            {Icons['rss']}
          </a>
        )}
      </div>
    )}
  </div>
)

export default EmbedPodcast
